module.exports = __webpack_public_path__ + "img/authCat.5aed42d5.svg";